<template>
    <el-select v-model="selectValue" @change="onChange">
        <el-option v-for="item in list" :key="item.id" :label="item.label" :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
        },
        value: {
            type: Number | String,
        },
        templateList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        selectValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('change', val);
            }
        },
        list() {
            return this.templateList.map(item => {
                return {
                    id: item.id,
                    label: item.name,
                };
            });
        },
    },
    methods: {
        onChange(val) {
            this.$emit('change', val);
        },
    },
};
</script>

<style></style>
